(ns ui.tailwind-merge-tokens)

(def size-tokens
  "Custom size keys of the tw2 Tailwind config. Each key is a `tailwind-merge`
   class group id. Each value lists the theme keys that belong to that group.

   `tailwind-merge` does not read the Tailwind config. It cannot place a name
   such as `w-card` in the `w` group. Two classes of the same group then both
   stay in the output. The order in the stylesheet decides which class wins.

   Add a name here when `tailwind.tw2.upstream.config.js` gets a new key in
   `width`, `maxWidth`, `minWidth`, `maxHeight` or `minHeight`. Do not add a
   name that `tailwind-merge` already knows. For example, it knows `max-w-md`."
  {"w"
   ["kanban-list-width"
    "kanban-list-collapsed-width"
    "kanban-toolbar-title-min"
    "modal-sm"
    "modal-md"
    "modal-lg"
    "modal-xl"
    "card"
    "table-selector-column-width"
    "table-sticky-column-width"
    "table-data-column-min-width"
    "table-peek-min-width"
    "drawer-sm"
    "drawer-md"
    "drawer-lg"
    "drawer-peek"
    "dropdown-button"
    "dropdown-panel-sm"
    "dropdown-panel-md"
    "dropdown-panel-lg"
    "stepper-scroll"]

   "max-w"
   ["kanban-list-width"
    "kanban-list-collapsed-width"
    "kanban-attribute-label-max-width"
    "modal-sm"
    "modal-md"
    "modal-lg"
    "modal-xl"
    "table-selector-column-width"
    "table-sticky-column-width"
    "drawer-sm"
    "drawer-md"
    "drawer-lg"
    "drawer-peek"
    "narrow-screen-card"
    "stepper-mobile"]

   "min-w"
   ["kanban-toolbar-title-min"
    "kanban-toolbar-arrange-min-width"
    "table-selector-column-width"
    "table-sticky-column-width"
    "table-data-column-min-width"
    "table-peek-min-width"
    "narrow-screen"]

   "max-h"
   ["modal-max-height"]

   "min-h"
   ["alert"]})

(defn add-size-tokens!
  "Adds `size-tokens` to the `classGroups` object of a `tailwind-merge` config.
   Changes the object in place and returns it.

   Call this function before the step that copies each group for the `tw2`
   prefix. The prefixed classes then get the same tokens."
  [class-groups]
  (doseq [[group tokens] size-tokens]
    (.push (aget class-groups group)
           (doto (js-obj)
             (aset group (clj->js tokens)))))
  class-groups)

(def outline-tokens
  "Custom outline keys of the tw2 Tailwind config. Each key is a `tailwind-merge`
   class group id. Each value is a vector of the class prefix and the theme keys
   that belong to that group.

   Here the prefix is not the group id, as it is for `size-tokens`. The groups
   `outline-w`, `outline-style` and `outline-color` all use the prefix `outline`.
   `tailwind-merge` knows only numbers as outline widths and only `solid` and the
   like as outline styles. It reads every other `outline-` name as an outline
   color. Without these keys, the width and the style of a named outline are merged
   away, and only one class stays.

   Add a name here when `tailwind.tw2.upstream.config.js` gets a new key in
   `outlineWidth`, `outlineStyle`, `outlineColor` or `outlineOffset`."
  {"outline-w"      ["outline" ["kanban-list-drop-outline-width"]]
   "outline-style"  ["outline" ["kanban-list-drop-outline-style"]]
   "outline-color"  ["outline" ["kanban-list-drop-outline-color"]]
   "outline-offset" ["outline-offset" ["kanban-list-drop-outline-offset"]]})

(defn add-outline-tokens!
  "Adds `outline-tokens` to the `classGroups` object of a `tailwind-merge` config.
   Changes the object in place and returns it.

   Call this function before the step that copies each group for the `tw2`
   prefix. The prefixed classes then get the same tokens."
  [class-groups]
  (doseq [[group [prefix tokens]] outline-tokens]
    (.push (aget class-groups group)
           (doto (js-obj)
             (aset prefix (clj->js tokens)))))
  class-groups)
